import * as React from 'react';
import { StickyCallToAction, Price } from '@grandvisionhq/common';
import { SolutionsUnitLabel } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

/**
 * @deprecated
 */ const SolutionsStickyCTA = ({ ctaButton  })=>{
    const { currency  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const unitPrice = activeVariant.purchaseTypePrices && activeVariant.purchaseTypePrices[state.configurations.purchaseType];
    var _discountedPrice;
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: "legacy-solutions-sticky-cta",
        button: ctaButton,
        price: unitPrice && /*#__PURE__*/ React.createElement(Price, {
            value: (_discountedPrice = unitPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : unitPrice.originalPrice,
            currency: currency,
            centAmount: true
        }),
        priceSubtitle: /*#__PURE__*/ React.createElement(SolutionsUnitLabel, {
            className: "legacy-solutions-sticky-cta__subtitle"
        })
    });
};

export { SolutionsStickyCTA };
//# sourceMappingURL=SolutionsStickyCTA.js.map
